import { render, staticRenderFns } from "./shopify-details.vue?vue&type=template&id=42a6f856&scoped=true&"
import script from "./shopify-details.vue?vue&type=script&lang=js&"
export * from "./shopify-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a6f856",
  null
  
)

export default component.exports